import React, { Component } from 'react';

import { AppList, ExternalLink } from 'components';
import './App.css';
import manumaps_logo from 'images/manumaps.png';
import pokedex_logo from 'images/pokedex.png';
import redux_full_socket_logo from 'images/redux-full-socket.png';
import bottom_sheet_logo from 'images/bottom-sheet.png';
import draggable_polyline_logo from 'images/draggable-polyline.png';
import flip_logo from 'images/flip.png';
import yell_logo from 'images/yell.png';
import path_logo from 'images/path.png';


const apps = [
  {
    name: 'ManuPath',
    href: 'https://path.manufont.com',
    image: path_logo
  },
  {
    name: 'ManuMaps',
    href: 'https://maps.manufont.com',
    image: manumaps_logo
  },
  {
    name: 'react-swipeable-bottom-sheet',
    href: 'https://manufont.github.io/react-swipeable-bottom-sheet',
    image: bottom_sheet_logo
  },
  {
    name: 'react-leaflet-draggable-polyline',
    href: 'https://manufont.github.io/react-leaflet-draggable-polyline',
    image: draggable_polyline_logo
  },
  {
    name: 'Pokedex',
    href: 'https://pokedex.manufont.com',
    image: pokedex_logo
  },
  {
    name: 'redux-full-socket',
    href: 'https://redux-full-socket.manufont.com',
    image: redux_full_socket_logo
  },
  {
    name: 'ManuFlip',
    href: 'https://flip.manufont.com',
    image: flip_logo
  },
  {
    name: 'ManuYell',
    href: 'https://yell.manufont.com',
    image: yell_logo
  },
]

class App extends Component {
  render() {
    return (
      <div className="App">
        <div className='header'>
          <h1 className='title'>Emmanuel Fonteneau</h1>
          <h3 className='subtitle'>Software&nbsp;engineer, full‑stack&nbsp;developer</h3>
          <div className='external-links'>
            <ExternalLink
              icon='github'
              profile='manufont'
              href='https://github.com/manufont'
            />
            <ExternalLink
              icon='linkedin'
              profile='manufont'
              href='https://www.linkedin.com/in/manufont/'
            />
          </div>
        </div>
        <AppList apps={apps}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js